import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { Menu } from "components";

const MenuButton = styled.div`
  display: ${(props) => (props.location.pathname === "/" ? "none" : "block")};
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 10;
  padding: 10px;
  background-color: #feffff;
  border-radius: 45px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  padding: 14px 10px;
  transform: scale(0.65);
`;

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuActive: false,
    };
  }

  toggleMenu = () => {
    this.setState((prevState) => ({ menuActive: !prevState.menuActive }));
  };

  render() {
    const { location } = this.props;
    const { menuActive } = this.state;
    const activeClass = menuActive ? "is-active" : "";
    return (
      <div>
        <MenuButton location={location} onClick={this.toggleMenu}>
          <button
            className={`hamburger hamburger--squeeze ${activeClass}`}
            type="button"
          >
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </button>
        </MenuButton>
        <Menu menuActive={menuActive} toggleMenu={this.toggleMenu} />
      </div>
    );
  }
}

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.jsx